/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
  //FAQ page Accordian
  $('.faq-body h5').click(function(e) {
    e.preventDefault();
    let $this = $(this);
    if ($this.next().hasClass('show')) {
      $this.next().slideUp(350);
      $this.next().removeClass('show');
      $this.removeClass('active-accordian');
    } else {
      $this.parent().parent().find('.faq-inner-body').removeClass('show');
      $('.faq-body h5').removeClass('active-accordian');
      $this.parent().parent().find('.faq-inner-body').slideUp(350);
      $this.next().toggleClass('show');
      $this.next().slideToggle(350);
      $this.toggleClass('active-accordian');
    }
  });  

  $(document).on('click', '.rebuy-button, .rebuy-button span', function() {
    var $this = $(this); // Declare $this here
    var interval = setInterval(doStuff, 100);
    function doStuff() {  
      if (!$this.parents(".rebuy-product-actions").find(".rebuy-button").hasClass("working")) {
        clearInterval(interval);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
        }));  

        if(!$this.closest("#sidebar-cart").hasClass("Drawer")){
          var cartDrawerButtonSelector = "Header__Icon Icon-Wrapper Icon-Wrapper--clickable ";
          var cartDrawerButton = document.getElementsByClassName(cartDrawerButtonSelector)[3];
          cartDrawerButton.click();

          setTimeout(function () {
            Rebuy.init(); 
          }, 2500);
        }        
      }
    }
  });
})

var swiper = new Swiper(".available-collection-slider", {
  slidesPerView: 4,
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      spaceBetween: 10,
      slidesPerColumn: 2, 
    },
    767: {
      slidesPerView: 2,
      spaceBetween: 10,
      slidesPerColumn: 2, 
    },
    991: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    992: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
  },
});

// Select all »a« elements with a parent class »links« and add a function that is executed on click
$( '.upcoming-richtext--wrapper a' ).on( 'click', function(e){
	
  // Define variable of the clicked »a« element (»this«) and get its href value.
  var href = $(this).attr( 'href' );
  
  // Run a scroll animation to the position of the element which has the same id like the href value.
  $( 'html, body' ).animate({
		scrollTop: $( href ).offset().top - 180
  }, '1000' );
	
  // Prevent the browser from showing the attribute name of the clicked link in the address bar
  e.preventDefault();

});

if ($(window).width() < 767){
  window.onload = function(){
    let player = document.getElementById("mob_upcoming__video"),
        play = document.getElementById("play-btn"),
        pause = document.getElementById("pause-btn");
    
    play.addEventListener("click",function(){
      player.play();
      this.closest('.upcoming-video-content').classList.add("pause-video");
    });
  
    pause.addEventListener("click",function(){
      player.pause();
      this.closest('.upcoming-video-content').classList.remove("pause-video");
    });
  }
}else{
  window.onload = function(){
    let player = document.getElementById("upcoming__video"),
        play = document.getElementById("play-btn"),
        pause = document.getElementById("pause-btn");
    
    play.addEventListener("click",function(){
      player.play();
      this.closest('.upcoming-video-content').classList.add("pause-video");
    });
  
    pause.addEventListener("click",function(){
      player.pause();
      this.closest('.upcoming-video-content').classList.remove("pause-video");
    });
  }
}

